import { Avatar, Box, Button, FormControl, Grid, MenuItem, Select, TextField } from "@mui/material"
import { LivisTabs } from "../../../components/Tabs"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LivisChipAutocomplete from "../../../components/Form/Input/LivisChipAutocomplete";
import { useEffect, useState } from "react";
import { t } from "i18next";
import LivisModal from "../../../components/Modals/LivisModal";
import { useNavigate, useParams } from "react-router-dom";
import { axios } from "../../../helpers/axios";
import NoDataTemplate from "../../../components/Layouts/NoData/NoDataTemplate";
import { useDispatch } from "react-redux";
import { setProcessName } from "../../../store/actions";
import { livisAlert } from "../../../helpers/alert";
import BoundingBoxCanvas from "./BoundingBoxCanvas";
import { color } from "highcharts";
import LandingMain from "../../../components/Layouts/Landing/MainLayout";
import { LivisPagination } from "../../../components/Pagination";
import "../styles/class-based-augmentation.scss"

// Main component for class-based augmentation workflow
const ClassBasedAugmentation = () => {
    // State variables for UI and data
    const [classes, setClasses] = useState<any>([])
    const [suggestedClasses, setSuggestedClasses] = useState([])
    const [defaultSuggestion] = useState(["Feature 1", "Feature 3"]);
    const [openModal, setOpenModal] = useState<boolean>(false);
    const [markedROI, setMarkedROI] = useState<boolean>(false);
    const [processes, setProcesses] = useState(["Select a Process"])
    const [selectedProcess, setSelectedProcess] = useState("")
    const [tags, setTags] = useState<any>([])
    const [responseImages, setResponseImages] = useState<any>([])
    const [paginationFrequency, setPaginationFrequency] = useState(20)
    const [imageData, setImageData] = useState<any>([])
    const [currentPage, setCurrentPage] = useState(1)
    const [startCount, setStartCount] = useState(0)
    const [openImage, setOpenimage] = useState(0)
    const [syntheticImages, setSyntheticImages] = useState([])
    const [syntheticImagesModal, setSyntheticImagesModal] = useState(false)
    const [selectedImage, setSelectedImage] = useState("")
    const [showImageModal, setShowImageModal] = useState(false)
    const [selectedBoundingBox, setSelectedBoundingBox] = useState<any>({})
    
    // Props for the landing page layout
    const landing_page_props = {
      "livis_logo": process.env.PUBLIC_URL + '/image/icons/lincode_livis.svg',
      "search_icon": process.env.PUBLIC_URL + '/image/icons/search.svg',
      "livis_hamburger": process.env.PUBLIC_URL + '/image/icons/hamburger.svg',
      "setting_icon": process.env.PUBLIC_URL + '/image/icons/settings.svg',
      "setting_icon_bold": process.env.PUBLIC_URL + '/image/icons/settings_bold.svg',
      "alert_icon": process.env.PUBLIC_URL + '/image/icons/alert.svg',
      "alert_icon_bold": process.env.PUBLIC_URL + '/image/icons/alert_bold.svg',
      "profile_icon": process.env.PUBLIC_URL + '/image/icons/profile.svg',
      "intro_icon": process.env.PUBLIC_URL + '/image/misc/intro_icon.svg',
      "page_title": "Inspection Station"
  }

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const { marked } = useParams()
    
    // Function to set form value and fetch images by tags
    const set_form_value = async(name :any, value :any) => {
      console.log(`Setting form value for ${name}:`, value);
      setTags(value)
      // Ensure the selected process is always the first tag
      if(tags[0] != selectedProcess ){
        tags.unshift(selectedProcess);
      }
      const payload = {
        "limit_to": paginationFrequency,
        "current": currentPage,
        "tags": tags,
      }
      // Fetch images by tags from backend
      const response = await axios.post("synthetic_data/get_images_by_tags/", payload)
      console.log("Response ------->",response?.data)
      setResponseImages(response?.data?.data?.images)
      setImageData(response?.data?.data)
    };
    
    // On mount, fetch processes if not in marked mode
    useEffect(() => {
      if(!marked){
        getProcesses()
      }
    } , [])

    // Fetch available manufacturing processes
    const getProcesses = async () => {
      const response = await axios.get("synthetic_data/get_manufacturing_processes/")
      setProcesses(response?.data?.data)
      if(response?.data.data){
        setSelectedProcess(response?.data?.data[0])
        dispatch(setProcessName(response?.data?.data[0]))
      }
    }

    // Fetch images when tags, pagination, or page changes
    useEffect(() => {
      if(tags.length){
        set_form_value("tags", tags)
      }
      setStartCount(paginationFrequency * (currentPage - 1) + 1);
    }, [paginationFrequency, currentPage])

    // Handle closing of synthetic images modal and reset state
    const handleCloseModal = () => {
      setSyntheticImagesModal(false)
      navigate("/app/class-based-augmentation/")
      localStorage.removeItem("selectedImage")
      localStorage.removeItem("partId")
      localStorage.removeItem("count")
      window.location.reload(); 
      // setToggleUdt(false)
      // localStorage.removeItem("syntheticImages")
    }


    // const handleExport = () => {
    //   setSyntheticImagesModal(false)
    //   navigate("/app/part/data/"+localStorage.getItem("partId"))
    //   localStorage.removeItem("selectedImage")
    //   // localStorage.removeItem("partId")
    // }


    const handleNavigate = (img :any) => {
        navigate("/app/class-based-augmentation/roi/"+responseImages[img]?._id+"/"+responseImages[img]?.part_id)
        localStorage.setItem("selectedImage", responseImages[img]?._id)
        localStorage.setItem("partId", responseImages[img]?.part_id)
    }

    // Fetch all synthetic images for the selected part/image
    const getAllSyntheticImages = async () => {
        // window.location.reload();
        localStorage.setItem("count", "1")
        const image_id = localStorage.getItem("selectedImage")  
        const part_id = localStorage.getItem("partId")

        const payload = {
          part_id : part_id,
          image_document_id : image_id
        }
        // Fetch synthetic images from backend
        const response = await axios.post("synthetic_data/get_synthetic_data/", payload)
        if(response?.status != 200){
          livisAlert(`${t("Error Fetching Images")}`, "Error")
          return
        } 
        setSyntheticImages(response?.data?.data?.images_list)
        setSyntheticImagesModal(true)
        // setToggleUdt(true)
        // localStorage.setItem("syntheticImages", JSON.stringify(response?.data?.data?.images_list))
        // window.location.reload();
        
        console.log("reponse synthetic data", response?.data?.images_list)
        // setSyntheticImagesModal(true)
    
      }

    // Handle ROI marked state and fetch synthetic images if needed
    const handleMarkedROI = () => {
        if(marked){
          getAllSyntheticImages()
        }
        console.log(marked, "<<<<<<<<--------------------------")
    }

    // On mount, handle marked ROI and reload logic
    useEffect(() => {
    
    if(localStorage.getItem("count") != "1" && marked){
      localStorage.setItem("count", "0")
    }


      if(localStorage.getItem("count") == "0" && marked){
        window.location.reload()
      }
      handleMarkedROI() 
    }, [])

    // Handle "Generate Images" button click
    const handleGenerateImages = () => {
        setOpenModal(false)
        navigate("/class-based-augmentation")
        setMarkedROI(false)
    }

    // Handle process selection change
    const handleSetProcess = (e :any) => {
        const {value} = e.target
        setSelectedProcess(value)
        dispatch(setProcessName(value))
        // classes[0] = value
    }

    console.log("Response images ----------->", responseImages)

    // Handle pagination frequency change
    const handlePagination = (e :any) => {
      const {value} = e.target
      setPaginationFrequency(parseInt(value))
    }

    // Go to previous page in pagination
    const handlePrevPage = () => {
      if (currentPage > 1)
          setCurrentPage(currentPage - 1);
      //console.log("prev page")
    }

    // Go to next page in pagination
    const handleNextPage = () => {
        setCurrentPage(currentPage + 1);
        //console.log("next page")
    }

    // Open image modal with bounding boxes
    const handleOpenimage = (url: any, boxes: any) => {
      setSelectedImage(url)
      setShowImageModal(true)
      console.log(boxes, "boxes")
      // Format bounding box data for the canvas
      const newBoxes = boxes.map((box: any) => {
        return {
          x: box.x,
          y: box.y,
          w: box.w,
          h: box.h,
          cls: box.cls,
          color: box.color
        }
      })
      console.log("newBoxes", newBoxes)
      setSelectedBoundingBox(newBoxes)
    }

    // Close image modal
    const handleCloseImageModal = () => {
      setShowImageModal(false)
    }

    // Download synthetic images (placeholder)
    const handleDownload = async () => {
      console.log("Download")
      const response = await axios.get("") 
    }

    // Main render
    return (
      <LandingMain landing_page_props={landing_page_props}>

            {/* Header section with filters and process selection */}
            <Box className="livis-manage-user-header livis-manage-part-header livis-manage-data-header">

                <Box className="livis-manage-user-filters-wrap" display={"flex"} alignItems={"center"}>
                <Box className="livis-manage-user-filters-wrap">
                 <FormControl variant="standard" >
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    value={selectedProcess}
                                    onChange={handleSetProcess}
                                    IconComponent={(props) => (<ExpandMoreIcon {...props} />)}
                                >
                                    {processes?.map((item: any, index: number) => (
                                        <MenuItem className="livis-menu-item" key={`${item}-filter-${index}`} value={item}>{t(item)}</MenuItem>
                                    ))}
                                </Select>
                    </FormControl>
                    </Box>
                    {selectedProcess &&                     
                    <Box className="livis-manage-user-filters-wrap" ml={2}>
                    <LivisChipAutocomplete
                        label_name={t("Tags")}
                        name="classes"
                        list={classes}
                        setList={setClasses}
                        sugesstedParameters={suggestedClasses}
                        setSugesstedParameters={setSuggestedClasses}
                        set_form_value={set_form_value}
                        type="classes"
                        defaultSuggestion={defaultSuggestion}
                    />
                    </Box>
                    }
                </Box>

                {/* <Box className="livis-manage-user-add-pagination-wrap livis-data-management-add-data-btn">
                    <Box className="livis-manage-user-add-user-wrap livis-manage-user-add-role-wrap">
                        <div className="livis-create-btn-wrap">
                            <Button className="livis-create-btn" variant="outlined" endIcon={<Avatar className='livis-inspection-station-add-station-avatar' src="add_icon_path" />}
                            onClick={() => setOpenModal(true)}
                            >
                                Open Modal
                            </Button>
                        </div>
                    </Box>
                </Box> */}
            </Box>
            <div className="livis-manage-data-image-grid-sub-header">
                <Grid
                    className="livis-manage-data-image-grid-sub-header-content"
                    container
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={5}
                        lg={5}
                        container
                        justifyContent="start"
                        flexWrap="wrap"
                    >
                        <LivisTabs
                            value="all"
                            onChange={() => { /* single static tab, nothing to switch to */ }}
                            ariaLabel="secondary tabs example"
                            tabs={[{ value: "all", label: t("All") }]}
                        />
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={6}
                        md={7}
                        lg={7}
                        container
                        justifyContent="end"
                        flexWrap="wrap"
                        className="livis-manage-data-sortby-pagination-wrap"
                    >

                        <LivisPagination
                            currentPage={currentPage}
                            pageLength={paginationFrequency}
                            totalCount={imageData?.total || 0}
                            startCount={startCount}
                            onPrev={handlePrevPage}
                            onNext={handleNextPage}
                            frequency={{
                                value: paginationFrequency.toString(),
                                onChange: (value: string) => handlePagination({ target: { value } }),
                                options: ["20", "50", "100", "200"],
                            }}
                        />
                    </Grid>
                </Grid>

                {/* Static text for the image type */}
                {
                  responseImages.length ?
                    <>
                      <p>All Images</p>
                      <div className="livis-usecase-data livis-usecase-data-modifier" 
                      
                    //  style={{ height: "100%", overflow: "auto" }}
                       >
                  <div className="livis-usecase-cards-wrap livis-usecase-cards-wrap-modifier" 
                  
                  // style={{
                  //   height: "70vh",
                  //   overflow: "auto",
                  // }}
                  >

                          <Grid container className="livis-usecase-card-wrap">
                              {responseImages.map((item :any, index :any) => (
                                <Grid key={index} item lg={2} md={3} sm={4} xs={6} className={"livis-manage-data-card-wrap"}>
                                      <img src={item?.file_url} className="livis-part-data-card-thumbnail"
                                      onClick={() => handleNavigate(index)}
                                      />
                                  </Grid>
                              ))}
                          </Grid>
                              </div>
                      </div>
                    </>
                  :

                  <NoDataTemplate />
                }

            </div>
                
            {/* Modal for marking ROI and generating images */}
            <LivisModal
              modal_open={openModal || markedROI}
              size="medium"
              title={t("Class Based Augmentation")}
              disable_outside_click={true}
              cancel_icon={true}
              animation_type={"slideup"}
              livis_dismiss_btn={handleCloseModal}
            >
              <div
                // style={{
                //   display: "flex",
                //   flexDirection: "row",
                //   height: "100%",
                // }}
                className="livis-class-based-augmentation-modal-content"
              >
                {/* Left side: Image */}
                <Box
                  className="livis-testing-inference-result-image-container livis-class-based-augmentation-image-container"
                  // style={{
                  //   flex: 1,
                  //   display: "flex",
                  //   justifyContent: "center",
                  //   alignItems: "center",
                  //   position: "relative", // Enable relative positioning for the button
                  //   marginRight: "1rem",
                  // }}
                >
                  {/* Image */}
                  <img
                    src={responseImages[openImage]?.file_url}
                    alt="ROI"
                    className="livis-part-data-card-thumbnail livis-class-based-augmentation-response-image"
                    // style={{
                    //   maxWidth: "100%",
                    //   maxHeight: "100%",
                    //   borderRadius: "8px",
                    //   objectFit: "cover",
                    // }}
                  />

                  {
                    !markedROI &&
                    <Button
                      variant="contained"
                      size="medium"
                      className={`livis-modal-btn-round livis-inference-annotate-icon`}
                      onClick={() => handleNavigate(openImage)}
                      style={{
                        position: "absolute", // Position the button inside the container
                        bottom: "10px", // Place it slightly above the bottom edge
                        right: "10px", // Place it slightly inward from the right edge
                      }}
                    >
                      {t("Mark ROI")}
                    </Button>
                  }
                </Box>

                {/* Right side: TextBox */}
                <Box
                  style={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                    alignItems: "flex-end",
                  }}
                >
                  <TextField
                    id="outlined-basic"
                    variant="outlined"
                    placeholder="Enter the number of images needed ?"
                    style={{
                      width: "80%",
                      marginBottom: "1rem",
                    }}
                  />
                  <Button
                    variant="contained"
                    size="medium"
                    className={`livis-modal-btn-round livis-inference-annotate-icon`}
                    onClick={handleGenerateImages}
                    disabled={!markedROI}
                  >
                    {t("Generate Images")}
                  </Button>
                </Box>
              </div>
            </LivisModal>

            {/* Modal to show synthetic images after generation */}
            <LivisModal
                modal_open={syntheticImagesModal}
                size="medium"
                title={t("Synthetic Images")}
                disable_outside_click={true}
                cancel_icon={true}
                animation_type={"slideup"}
                livis_dismiss_btn={handleCloseModal}
                livis_modal_class={"livis-synthetic-augmentation-modal"}
              >
                <>
                <div className="livis-usecase-data" style={{ height: "90%", overflowY: "auto" }} >
                  <div className="livis-usecase-cards-wrap" style={{
                    height: "70vh",
                    overflowY: "auto",
                    overflowX: "hidden",
                    paddingRight: "1rem"
                  }
                  }>
    
                    <Grid container className="livis-usecase-card-wrap" >
                      {syntheticImages?.map((item :any, index) => (
                        <Grid key={index} item lg={4} md={3} sm={4} xs={6} className={"livis-manage-data-card-wrap"}>
                          <img src={item?.file_url} className="livis-part-data-card-thumbnail"
                            onClick={() => handleOpenimage(item?.file_url, item?.annotation_detection)}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </div>
                </div>
                <Grid container
                  justifyContent="flex-end" className='livis-part-manage-data-augmentation-container'>
                  <Button variant="outlined"
                    style={{
                      borderColor: "#1a26c1",
                      color: "#1a26c1"
                    }}
                    size="medium" className="livis-modal-btn-round livis-modal-cancel-close-btn"
                    onClick={handleCloseModal}
                  >
                    {t("Cancel")}
                  </Button>
                  {/* <Button size="medium"
                    // type='primary'
                    style={{
                      backgroundColor: "#1a26c1"
                    }}
                    variant="contained"
                    className="livis-modal-btn-round livis-modal-cancel-close-btn"
                    onClick={handleCloseModal}
                  >
                    {t("Export")}
                  </Button> */}
                  <Button size="medium"
                    // type='primary'
                    style={{
                      backgroundColor: "#1a26c1"
                    }}
                    variant="contained"
                    className="livis-modal-btn-round livis-modal-cancel-close-btn"
                    onClick={handleDownload}
                  >
                    {t("Download")}
                  </Button>
                </Grid>
                </>
    
              </LivisModal>

            {/* Modal to show a single synthetic image with bounding boxes */}
            {
              selectedImage ?
              <LivisModal 
                modal_open={showImageModal}
                size="medium"
                title="Synthetic Image"
                disable_outside_click={true}
                cancel_icon={true}
                animation_type={"slideup"}
                livis_dismiss_btn={handleCloseImageModal}
                // livis_modal_class={"livis-synthetic-augmentation-modal"}
              >
                <Box className="livis-testing-inference-result-image-container">
                  {/* <img src={selectedImage} width={"100%"} height={"100%"} /> */}
                  <BoundingBoxCanvas boundingElement={{ url: selectedImage, bounding_box: selectedBoundingBox }} />
                </Box>
              </LivisModal>
              :

              null
            }


        </LandingMain>

    )
}

export default ClassBasedAugmentation